export const SETTINGS = [
    {id:"SendResponseConfirmation",name:"שלח לי מייל אישור לשליחת המשימה"}, 
    {id:"SendGradeNotification",name:"שלח לי מייל בעת עדכון הציון"},
    {id:"SendGradeCheckerNotes",name:"שלח לי את הערות הבודק במייל במידה וישנן"}
] 